'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var getCookie = exports.getCookie = function getCookie(name, cookies) {
  var value = '; ' + cookies;
  var splitCookies = value.split(';');
  if (splitCookies.length) {
    for (var i = 0; i < splitCookies.length; i++) {
      var parts = splitCookies[i].split('=');
      if (parts.length === 2 && parts[0].trim() === name) {
        return parts[1];
      }
    }
  }

  return null;
};


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/hub-http/static-1.158/js/helpers/cookies.js
// module id = 178
// module chunks = 0